import { apiSlice } from '../../../api/apiSlice';
import  * as constants  from '../../../constants';

export const ScorecardRulesHeaderSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getScorecardHeaderInfo: builder.query({
            query: (arg: any) => {
                const { year, month,scorecardVersionId } = arg;
                return {
                    url: constants.SCORECARD_HEADER_INFO,
                    params: { year, month,scorecardVersionId },
                };
            },
        }),
        getMetricHeaderInfo: builder.query({
            query: (arg: any) => {
                const { metricId,scorecardVersionId } = arg;
                return {
                    url: constants.METRIC_HEADER_INFO,
                    params: { metricId,scorecardVersionId },
                };
            },
        }),
    }),
});

export const { useGetScorecardHeaderInfoQuery } = ScorecardRulesHeaderSlice;
export const { useGetMetricHeaderInfoQuery } = ScorecardRulesHeaderSlice;
